module.exports = __webpack_public_path__ + "static/media/completed.d9380868.svg";